import React, { useEffect, useState } from "react";
import Select from "react-select";
import "../css/others/Table.css";
import { apiCall } from "../main/ApiCall";
import ToastPopup from "../popups/ToastPopup";
import { OptionType, createToastMessage, ToastMessage } from '../interFaces/interfaces';
const MappedHeaders: React.FC = () => {
  const [rawData, setRawData] = useState<Record<string, string>>({});
  const [mappedData, setMappedData] = useState<Record<string, string>>({});
  const [originalMappedData, setOriginalMappedData] = useState<Record<string, string>>({});
  const [allPossibleOptions, setAllPossibleOptions] = useState<OptionType[]>([]);
  const [isEditable, setIsEditable] = useState(false);
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [hasCompletedBulkUpload, setHasCompletedBulkUpload] = useState<boolean>(false);
  const clientId = localStorage.getItem("clientId");
  useEffect(() => {
    const checkBulkUploadJobs = async () => {
      try {
        const response = await apiCall("get", `/api/bulk-upload/job-master/paginated?clientId=${clientId}&page=0&size=10`);
        const hasCompletedJob = response?.content?.some((job: any) => job.jobStatus === "COMPLETED");
        setHasCompletedBulkUpload(hasCompletedJob);
      } catch (error) {
        console.error("Error checking bulk upload jobs:", error);
        setHasCompletedBulkUpload(false);
      }
    };
    const fetchClientMappings = async () => {
      try {
        const response = await apiCall("get", "/api/client-mappings", null, { clientId });
        const rawDataResponse = response?.rawData || {};
        const mappedDataResponse = response?.mappedData || {};
        setRawData(rawDataResponse);
        const transformedData = transformMappedData(mappedDataResponse, rawDataResponse);
        setMappedData(transformedData);
        setOriginalMappedData(transformedData);
        const uniqueOptions = (response?.headers || []).map((header: string) => ({ value: header, label: header }));
        setAllPossibleOptions([{ value: "", label: "Select an option" }, ...uniqueOptions]);
      } catch (error) {
        console.error("Error fetching client mappings:", error);
      }
    };
    const init = async () => { await checkBulkUploadJobs(); await fetchClientMappings(); };
    init();
  }, [clientId]);
  const transformMappedData = (mappedData: Record<string, string>, rawData: Record<string, string>) => {
    const transformedData: Record<string, string> = {};
    Object.entries(rawData).forEach(([rawKey, mappedKey]) => {
      transformedData[rawKey] = mappedData[mappedKey as string] || "";
    });
    return transformedData;
  };
  const handleDropdownChange = (rawKey: string, selectedOption: { value: string; label: string }) => {
    setMappedData((prev) => ({ ...prev, [rawKey]: selectedOption.value }));
  };
  const handleEditClick = async () => {
    if (!isEditable) {
      setIsEditable(true);
      return;
    }
    try {
      const transformedMappedData: Record<string, string> = {};
      Object.entries(mappedData).forEach(([rawKey, selectedValue]) => {
        const backendKey = rawData[rawKey];
        if (backendKey) {
          transformedMappedData[backendKey] = selectedValue;
        }
      });
      const dataToUpdate = { clientId, mappedData: transformedMappedData };
      await apiCall("put", "/api/client-mappings", dataToUpdate);
      setMessage(createToastMessage("Mapped Headers Updated Successfully!", "success", 3000));
      setOriginalMappedData(mappedData);
      setIsEditable(false);
      setTimeout(() => window.location.reload(), 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Error updating mappings";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleCancelClick = () => { setMappedData(originalMappedData); setIsEditable(false) };
  const handleBackClick = () => { window.history.back() };
  const shouldShowEditButton = !hasCompletedBulkUpload && Object.keys(rawData).length > 0;
  return (
    <div className="container">
      <div className="inner-container">
        <h1 className="title">Mapped Headers</h1>
        <div className="button-group">
          {isEditable && Object.keys(rawData).length > 0 && (
            <button className="cancel" onClick={handleCancelClick}>Cancel</button>
          )}
          {shouldShowEditButton && (
            <button className="save" onClick={handleEditClick}> {isEditable ? "Save" : "Edit"}</button>
          )}
        </div>
      </div>
      <div className="grid">
        {Object.keys(rawData).length === 0 && (
          <p className="no-data">There are no mapped headers found for this clientId.</p>
        )}
        {Object.entries(rawData).map(([rawKey]) => (
          <div key={rawKey} className="mapping-card">
            <label className="fieldlabel">{rawKey}</label>
            <Select className="Select" value={{ value: mappedData[rawKey] || "", label: mappedData[rawKey] || "Select an option" }} options={allPossibleOptions} onChange={(selectedOption) => handleDropdownChange(rawKey, selectedOption as { value: string; label: string })} isDisabled={!isEditable || hasCompletedBulkUpload} placeholder="Select an option" />
          </div>
        ))}
      </div>
      <div className="modal-buttons">
        <button className="button" onClick={handleBackClick}>Back</button>
      </div>
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default MappedHeaders;